import { render, staticRenderFns } from "./game-status.vue?vue&type=template&id=0613a4f4&scoped=true"
import script from "./game-status.vue?vue&type=script&lang=js"
export * from "./game-status.vue?vue&type=script&lang=js"
import style0 from "./game-status.vue?vue&type=style&index=0&id=0613a4f4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0613a4f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0613a4f4')) {
      api.createRecord('0613a4f4', component.options)
    } else {
      api.reload('0613a4f4', component.options)
    }
    module.hot.accept("./game-status.vue?vue&type=template&id=0613a4f4&scoped=true", function () {
      api.rerender('0613a4f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bet-panel/game-status.vue"
export default component.exports